import { render, staticRenderFns } from "./SignUpAuthResult.vue?vue&type=template&id=543916d4&scoped=true"
import script from "./SignUpAuthResult.vue?vue&type=script&lang=js"
export * from "./SignUpAuthResult.vue?vue&type=script&lang=js"
import style0 from "./SignUpAuthResult.vue?vue&type=style&index=0&id=543916d4&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543916d4",
  null
  
)

export default component.exports